export default "__VITE_ASSET__CD8SRn7S__"